import React from "react";
import classNames from "classnames";
import { Loader } from "@mantine/core";

import styles from "./button.module.scss";

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant: "primary" | "secondary" | "tertiary";
  size: "small" | "medium";
  isFullWidth?: boolean;
  tone?: "destructive";
  text?: "brand" | "normal";
  loading?: boolean;
};

export const Button = ({
  variant,
  size,
  className,
  type,
  isFullWidth,
  tone,
  text,
  children,
  loading,
  ...props
}: ButtonProps) => (
  <button
    className={classNames(
      styles.button,
      {
        [styles.variantPrimary]: variant === "primary",
        [styles.variantSecondary]: variant === "secondary",
        [styles.variantTertiary]: variant === "tertiary",
        [styles.sizeSmall]: size === "small",
        [styles.sizeMedium]: size === "medium",
        [styles.fullWidth]: isFullWidth,
        [styles.toneDestructive]: tone === "destructive",
        [styles.textBrand]: text === "brand",
      },
      className,
    )}
    type={type}
    {...props}
  >
    {loading ? <Loader className={styles.loadingSpinner} /> : children}
  </button>
);
